import { BolReviewFormValues } from "./bolReviewMappers";

const touchValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(touchValue);
  }
  if (value != null && typeof value === "object") {
    return Object.keys(value as Record<string, unknown>).reduce(
      (acc, key) => ({
        ...acc,
        [key]: touchValue((value as Record<string, unknown>)[key]),
      }),
      {} as Record<string, unknown>
    );
  }
  return true;
};

export const touchAllBolReviewFields = (
  values: BolReviewFormValues
): Record<string, unknown> => touchValue(values) as Record<string, unknown>;

export const getFirstFormErrorMessage = (errors: unknown): string | null => {
  if (!errors) return null;
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors)) {
    for (const item of errors) {
      const message = getFirstFormErrorMessage(item);
      if (message) return message;
    }
    return null;
  }
  if (typeof errors === "object") {
    for (const value of Object.values(errors as Record<string, unknown>)) {
      const message = getFirstFormErrorMessage(value);
      if (message) return message;
    }
  }
  return null;
};
